import { createContext } from "react";
import { TTableDataContextType } from "components/Table/context/index";

export const TableDataContext = createContext<TTableDataContextType>( // A mechanism for passing data through the component tree without having to pass props manually at every level
    {} as TTableDataContextType,
);

export default TableDataContext;
